import React, { useState } from 'react';
import '../../../css/huerto/scoring.css';
import { withRouter } from 'react-router-dom';
import ContractsService from '../../../../services/ContractsService';
import { withCookies } from 'react-cookie';
import Globals from '../../../../Globals';
import FunctionGeneral from '../functionsGeneral';
function TextoLanding(props) {
    const [parametrosLanding, setParametrosLanding] = useState(getTextoLandig);
    const [modalConfirmacion, setmodalConfirmacion] = useState(false);

    async function getTextoLandig() {
        var _response = await new ContractsService().getTextoLanding(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken
        );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            setParametrosLanding(response);
        }
    }

    async function actualizarTextoLaindig() {
        setmodalConfirmacion(false);
        var textActual = document.getElementById('textAreaAddActividad').value;
        var _response = await new ContractsService().updateTextoLanding(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            textActual
        );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            getTextoLandig();
        }
    }
    const printModalConfirmacion = () => {
        return (
            <div className="c-modal" aria-hidden={'false'}>
                <div className="c-modal__overlay js-modal-close"></div>
                <div
                    className="c-modal__wrapper modalFichaCliente"
                    role="dialog"
                    aria-labelledby="foo-bar-baz"
                >
                    <header className="c-modal__header">
                        <div className="o-layout__item u-11/12">
                            <label className="u-h3 u-ml-xsmall">
                                Actualización texto landing
                            </label>
                        </div>

                        <div className="u-1/12">
                            <button
                                onClick={() => setmodalConfirmacion(false)}
                                className="c-modal__close-btn  js-modal-close"
                                type="button"
                                aria-label="Close this dialog window."
                            />
                        </div>
                    </header>

                    <div className="c-modal__content">
                        <div className="o-layout__item u-1/1 u-text-left">
                            Desea actualizar el texto a mostrar en la matiz de
                            vencimiento?
                        </div>
                        <div className="o-layout__item u-1/2">
                            <button
                                className="CancelActividad c-btn--secondary c-btn"
                                style={{
                                    width: '140px',
                                    height: '40px',
                                    marginTop: '65px',
                                }}
                                onClick={() => actualizarTextoLaindig()}
                            >
                                Aceptar
                            </button>
                        </div>
                        <div className="o-layout__item u-1/2">
                            <button
                                className="CancelActividad c-btn--secondary c-btn"
                                style={{
                                    width: '140px',
                                    height: '40px',
                                    marginTop: '65px',
                                }}
                                onClick={() => setmodalConfirmacion(false)}
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    if (parametrosLanding.length === 1)
        return (
            <div
                className="o-page-wrap o-page-wrap--xsmall"
                style={{ height: '75vh' }}
            >
                <section className="o-content-section o-page-wrap o-page-wrap--xsmall">
                    {modalConfirmacion && printModalConfirmacion()}
                    <div className="o-component-wrapper u-hide@s">
                        <h3 className="u-text-center">Texto landing Huerto</h3>
                        <div className="fc-margintop-10">
                            <div className="o-layout__item u-1/2">
                                <label className="labelConsT u-text-muted u-1/1">
                                    Texto landing Actual
                                </label>
                                <label
                                    className="u-1/1 labelConsT"
                                    style={{ minHeight: '100px' }}
                                >
                                    {parametrosLanding[0].TPCVALORCONSTANTE}
                                </label>
                            </div>

                            <div className="o-layout__item u-1/1">
                                <label className="labelConsT u-text-muted u-1/2">
                                    Ultima Actualización
                                </label>
                                <label className="labelConsT u-text-muted u-1/2">
                                    Usuario de alta
                                </label>
                                <label className="labelConsT u-text-base  u-1/2">
                                    {new FunctionGeneral().formatFecha(
                                        parametrosLanding[0].TPDFECHAMODIFICACION.split(
                                            'T'
                                        )[0].split('-')
                                    )}
                                </label>
                                <label className="labelConsT u-text-base  u-1/2">
                                    {
                                        parametrosLanding[0]
                                            .TPCIDUSUARIOINFORMODIFICACION
                                    }
                                </label>
                            </div>
                        </div>

                        <div className="o-layout__item u-1/1 fc-margintop-10">
                            <label className="u-text-base u-1/2 u-text-left">
                                Ingrese el nuevo texto landing
                            </label>
                            <div className="input-div u-1/2">
                                <textarea
                                    maxLength={226}
                                    className="textAreaAddActividad"
                                    id="textAreaAddActividad"
                                />
                            </div>
                        </div>
                        <div className="o-layout__item u-1/1">
                            <button
                                className="c-btn scoring-table-button"
                                onClick={() => setmodalConfirmacion(true)}
                            >
                                Actualizar
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        );
    else return <div></div>;
}

export default withCookies(withRouter(TextoLanding));
